<template>
  <div class="logo-page">
    <div class="logo-container">
      <img :src="logo" alt="Aii Logo" class="logo-image" />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

// 只导入Aii01.png图片作为logo
import logo from '../img/logo/png/Aii01.png'

const router = useRouter()

onMounted(() => {
  // 3秒后自动跳转到介绍页面
  setTimeout(() => {
    router.push('/intro')
  }, 3000)
})
</script>

<style scoped>
.logo-page {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(
    to bottom,
    #e0e0e0 0%,
    #f0f0f0 25%,
    #ffffff 50%,
    #f0f0f0 75%,
    #e0e0e0 100%
  );
  background-attachment: fixed;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: pageFadeIn 0.5s ease-out;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  backface-visibility: hidden;
  transform: translateZ(0);
}

.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  animation: contentFadeIn 0.8s ease-out 0.2s both;
}

.logo-image {
  width: clamp(200px, 50vw, 600px);
  height: clamp(200px, 50vw, 600px);
  object-fit: contain;
  filter: none;
}

/* 页面淡入动画 */
@keyframes pageFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* 内容淡入动画 */
@keyframes contentFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式适配规则 - 简化，因为clamp已经处理了自适应 */
/* 横屏设备优化 */
@media (max-height: 500px) and (orientation: landscape) {
  .logo-image {
    width: clamp(160px, 40vw, 500px);
    height: clamp(160px, 40vw, 500px);
  }
}

/* 超小屏幕优化 */
@media (max-width: 360px) {
  .logo-image {
    width: clamp(180px, 44vw, 560px);
    height: clamp(180px, 44vw, 560px);
  }
}

/* 高DPI屏幕优化 */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .logo-image {
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
  }
}

/* 禁用动画（可访问性） */
@media (prefers-reduced-motion: reduce) {
  .logo-page,
  .logo-container {
    animation: none;
  }
}

/* 确保无内容溢出 */
.logo-page {
  -webkit-overflow-scrolling: touch;
}

/* 极简主义优化：移除所有可能的边框和轮廓 */
.logo-image:focus {
  outline: none;
}

/* 确保内容在背景之上 */
.logo-container {
  position: relative;
  z-index: 1;
  margin-top: -50px; /* 将logo向上移动50像素 */
}

/* 平滑滚动优化 */
html {
  scroll-behavior: smooth;
}
</style>